import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailX, Loader2 } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import api from "../lib/api";

export default function NewsletterUnsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("t");
  const [state, setState] = useState("loading");
  const [hint, setHint] = useState("");
  useEffect(() => {
    if (!token) { setState("not_found"); return; }
    api.get(`/newsletter/unsubscribe/${token}`).then(({ data }) => { setState(data.status); setHint(data.email_hint || ""); }).catch(() => setState("error"));
  }, [token]);
  const confirm = async () => {
    setState("loading");
    try { const { data } = await api.post(`/newsletter/unsubscribe/${token}`); setState(data.status); } catch { setState("error"); }
  };
  const msg = { loading: ["Un attimo…", "Stiamo verificando il link."], valid: ["Vuoi disiscriverti?", `Confermi di non voler più ricevere la newsletter all'indirizzo ${hint}?`],
    unsubscribed: ["Sei stato disiscritto", "Non riceverai più la nostra newsletter. Ci dispiace vederti andare: la guida resta sempre disponibile sul sito."],
    not_found: ["Link non valido o già usato", "Probabilmente eri già disiscritto. Se continui a ricevere email scrivici e sistemiamo subito."], error: ["Qualcosa è andato storto", "Riprova tra qualche minuto oppure contattaci."] }[state];
  return (
    <div className="min-h-screen bg-[#FAFAF7] paper-grain">
      <Navbar />
      <section className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="unsubscribe-page">
        {state === "loading" ? <Loader2 className="w-10 h-10 mx-auto text-[#0F4C81] animate-spin mb-6" /> : <MailX className="w-10 h-10 mx-auto text-[#C2593F] mb-6" />}
        <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-[#0B2A45] mb-3" data-testid="unsubscribe-title">{msg[0]}</h1>
        <p className="text-stone-600 mb-8">{msg[1]}</p>
        {state === "valid" ? (
          <button onClick={confirm} className="inline-flex rounded-full bg-[#C2593F] hover:bg-[#9A3412] text-white px-7 h-12 items-center font-semibold" data-testid="unsubscribe-confirm-btn">Sì, disiscrivimi</button>
        ) : (
          <Link to="/" className="inline-flex rounded-full bg-[#0F4C81] text-white px-7 h-12 items-center font-semibold" data-testid="unsubscribe-home-link">Torna alla home</Link>
        )}
      </section>
      <Footer />
    </div>
  );
}
